import advancedLocalStorage from './advancedLocalStorage';

function checkForCookieAndCreateLocalStorageItem(key: string) {
  const doesExistInLocalStorage = advancedLocalStorage.getItem(key);

  if (doesExistInLocalStorage) {
    return key;
  }

  const cookieValue = document.cookie
    .split('; ')
    .find((row) => row.startsWith(`${key}=`))
    ?.split('=')[1];

  if (!cookieValue) {
    return key;
  }

  advancedLocalStorage.setItem(key, cookieValue);

  document.cookie = `${key}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;

  return key;
}

function getCookieOrLocalStorageItem(key: string) {
  const verifiedKey = checkForCookieAndCreateLocalStorageItem(key);

  return advancedLocalStorage.getItem(verifiedKey);
}

export default {
  checkForCookieAndCreateLocalStorageItem,
  getCookieOrLocalStorageItem,
};
